module.exports = __webpack_public_path__ + "img/sendsms-icon.72a59dfe.svg";